import type { CustomNode, CustomNodeData } from '@src/components/custom-nodes/types';
import type { ReactFlowInstance } from 'reactflow';

interface UpdateNodeProps {
  reactFlowInstance?: ReactFlowInstance;
}
export const updateNode = ({ reactFlowInstance }: UpdateNodeProps) => (
    id: string, dataPayload: Partial<CustomNodeData>, payload: Partial<CustomNode> = {}
  ) => {
  const { setNodes } = reactFlowInstance!;

  setNodes((nodes) => {
    const nodeIndex = nodes.findIndex((n) => n.id === id);
    const newNodes = [...nodes];
    const nodeToUpdate = newNodes[nodeIndex] ?? {};

    newNodes[nodeIndex] = {
      ...nodeToUpdate,
      data: {
        ...nodeToUpdate.data as CustomNodeData,
        ...dataPayload
      },
      ...payload
    };

    return newNodes;
  });

  return {
    success: true,
  };
}
